import axios from "axios";
import toast from "react-hot-toast";
import {  useSelector } from "react-redux";

import { useCallback, useMemo } from "react";
import { constants } from "@lib/constants";

import useAxiosLogout from "./useAxiosLogout";

const axiosPrivate = axios.create({
  baseURL: constants.BASE_URL,
  headers: {
    "Content-Type": "application/json",
    // "Content-Type": "multipart/form-data",
  },
});
export default function useAxiosPrivate() {
  


  
  const accessToken = useSelector((state) => state.authReducer.accessToken);
  const { logOut: nativeLogout } = useAxiosLogout();

  const headers = useMemo(
    () => ({
      authorization: `bearer ${accessToken}`,
      "Content-Type": "application/json",
    }),
    [accessToken],
  );

  const handleError = useCallback(
  (error) => {
    toast.error(error?.response?.data?.message);

    if (error?.response?.status === 401) {
      nativeLogout();
    }
  },
  [nativeLogout],
);

  const axiosGet = useCallback(
    async (url, params) => {
      try {
        const finalUrl = params ? `${url}?${params}` : url;
        const response = await axiosPrivate.get(finalUrl, { headers });
        return response.data;
      } catch (error) {
        handleError(error);
        if (error?.response?.data) return error.response.data;
      }
    },
    [headers, handleError],
  );

  const axiosPost = useCallback(
    async (url, data) => {
      try {
        const response = await axiosPrivate.post(url, data, {
          headers: {
            authorization: `bearer ${accessToken}`,
          },
        });
        return response.data;
      } catch (error) {
        handleError(error);
        if (error?.response?.data) return error.response;
      }
    },
    [accessToken, handleError],
  );

  const axiosPatch = useCallback(
    async (url, data) => {
      try {
        const response = await axiosPrivate.patch(url, data, {
          headers: {
            authorization: `bearer ${accessToken}`,
          },
        });
        return response.data;
      } catch (error) {
        handleError(error);
      }
    },
    [accessToken, handleError],
  );

  const axiosPut = useCallback(
    async (url, data) => {
      try {
        const response = await axiosPrivate.put(url, data, {
          headers: {
            authorization: `bearer ${accessToken}`,
          },
        });
        return response.data;
      } catch (error) {
        handleError(error);
      }
    },
    [accessToken, handleError],
  );

  const axiosDelete = useCallback(
    async (url, data) => {
      try {
        const response = await axiosPrivate.delete(
          url,
          { data },
          {
            headers: {
              authorization: `bearer ${accessToken}`,
            },
          },
        );
        return response.data;
      } catch (error) {
        handleError(error);
      }
    },
    [accessToken, handleError],
  );

  const axiosCustom = useCallback(
    async (url, method, data, customHeaders) => {
      try {
        let response = await axios({
          method,
          url,
          data,
          headers: customHeaders,
        });

        return response.data;
      } catch (error) {
        handleError(error);
      }
    },
    [handleError],
  );

  return useMemo(
    () => ({
      axiosGet,
      axiosPost,
      axiosPatch,
      axiosDelete,
      axiosPut,
      axiosCustom,
    }),
    [axiosGet, axiosPost, axiosPatch, axiosDelete, axiosPut, axiosCustom],
  );
}
